import axios from 'axios';
import { baseAuth } from 'services/constants';

const fetchFromApiServer = (requestType, url, data, options) => {
  return fetchApiWrapper(url, requestType, data, options);
};

export function getHeaderConfig(requestType, options) {
  const config = {
    headers: {
      'Content-Type':
        requestType === 'MULTIPART'
          ? 'multipart/form-data'
          : 'application/json',
      Accept: '*/*',
    },
    params: { ...options },
    timeout: 60 * 10 * 1000,
    withCredentials: true,
  };
  return config;
}

export function getHeaderConfigRTK(requestType) {
  const config = {
    headers: {
      'Content-Type':
        requestType === 'MULTIPART'
          ? 'multipart/form-data'
          : 'application/json',
      Accept: '*/*',
    },
    timeout: 60 * 10 * 1000,
    withCredentials: true,
  };
  return config;
}

const fetchApiWrapper = async (uri, requestType, data, options = {}) => {
  const url = `/api/${uri}`;
  const port = process.env.REACT_APP_API_PORT;
  const baseURL = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
  const config = getHeaderConfig(requestType, options);
  let response = null;
  if (requestType === 'GET') {
    response = await axios({ url, baseURL, method: 'get', ...config });
  } else if (requestType === 'POST') {
    response = await axios({ url, baseURL, method: 'post', data, ...config });
  } else if (requestType === 'DELETE') {
    response = await axios({ url, baseURL, method: 'delete', data, ...config });
  } else if (requestType === 'PUT') {
    response = await axios({ url, baseURL, method: 'put', data, ...config });
  } else if (requestType === 'PATCH') {
    response = await axios({ url, baseURL, method: 'patch', data, ...config });
  } else if (requestType === 'MULTIPART') {
    response = await axios({ url, baseURL, method: 'post', data, ...config });
  } else if (requestType === 'JSON') {
    response = await axios.get({ url, baseURL });
  }
  return response;
};

export default fetchFromApiServer;
